import { jsx as _jsx } from "preact/jsx-runtime";
import Lang from '@fullcalendar/core/locales/ja';
import '@fullcalendar/core/vdom.js';
import DayGridPlugin from '@fullcalendar/daygrid';
import InteractionPlugin from '@fullcalendar/interaction';
import TimeGridPlugin from '@fullcalendar/timegrid';
import dayjs from "dayjs";
import { Component } from "preact";
import { getCurrentPreserves, getHolidays } from "../../api/Client";
import { compareBetween } from "../../util/DayJs";
import { PreactFullCalendar } from "./CalendarComponent";
export class PreserveSchedulerComponent extends Component {
    constructor(props) {
        super(props);
        this.options = {};
        this.state = {
            duration: 60,
            intermission: 0,
            preserveStartDateTime: dayjs().hour(0).minute(0).second(0),
            preserveEndDateTime: dayjs('9999-12-31 23:59:59'),
            openingTime: '00:00:00',
            closingTime: '24:00:00'
        };
        this.selectAllow = this.selectAllow.bind(this);
        this.options = {
            plugins: [DayGridPlugin, TimeGridPlugin, InteractionPlugin],
            initialView: 'timeGridWeek',
            height: 'auto',
            locale: Lang,
            headerToolbar: {
                start: 'prev',
                center: 'today',
                end: 'next'
            },
            selectLongPressDelay: 100,
            selectOverlap: false,
            selectable: true,
            slotDuration: { minute: 60 },
            slotMinTime: '00:00:00',
            slotMaxTime: '24:00:00',
            unselectAuto: false,
            allDaySlot: false,
            selectAllow: this.selectAllow
        };
    }
    componentWillReceiveProps(props) {
        const planGroup = props.planGroup;
        console.debug(planGroup);
        let preserveStartDateTime = dayjs().hour(0).minute(0).second(0);
        if (planGroup?.preserveStartDate != null) {
            console.debug(planGroup.preserveStartDate);
            preserveStartDateTime = preserveStartDateTime.year(planGroup.preserveStartDate[0]).month(planGroup.preserveStartDate[1] - 1).date(planGroup.preserveStartDate[2]);
        }
        if (planGroup?.preserveStartTime != null) {
            preserveStartDateTime = preserveStartDateTime.hour(planGroup.preserveStartTime[0]).minute(planGroup.preserveStartTime[1]);
        }
        this.setState({ preserveStartDateTime: preserveStartDateTime });
        // 終了日時も同様
        let preserveEndDateTime = dayjs('9999-12-31 23:59:59');
        if (planGroup?.preserveEndDate != null) {
            console.debug(`preserveEndDate => ${planGroup.preserveEndDate}`);
            preserveEndDateTime = preserveEndDateTime.year(planGroup.preserveEndDate[0]).month(planGroup.preserveEndDate[1] - 1).date(planGroup.preserveEndDate[2]);
        }
        if (planGroup?.preserveEndTime != null) {
            preserveEndDateTime = preserveEndDateTime.hour(planGroup.preserveEndTime[0]).minute(planGroup.preserveEndTime[1]);
        }
        this.setState({ preserveEndDateTime: preserveEndDateTime });
        if (planGroup?.closingTime) {
            this.setState({ closingTime: planGroup.closingTime });
        }
        if (planGroup?.openingTime) {
            this.setState({ openingTime: planGroup.openingTime });
        }
        const duration = props.plan?.requirementMinute ?? 60;
        const intermission = props.plan?.intermissionMinute ?? 0;
        const preserveStartDate = props.planGroup?.preserveStartDate;
        let expectStartDate = dayjs();
        if (preserveStartDate) {
            expectStartDate = expectStartDate.set('date', preserveStartDate[2]).set('months', preserveStartDate[1] - 1).set('years', preserveStartDate[0]);
        }
        console.debug(`start day => ${expectStartDate}`);
        this.setState({
            duration: duration,
            intermission: intermission
        });
        this.options = {
            plugins: [DayGridPlugin, TimeGridPlugin, InteractionPlugin],
            initialView: 'timeGridWeek',
            height: 'auto',
            locale: Lang,
            headerToolbar: {
                start: 'prev',
                center: 'today',
                end: 'next'
            },
            events: (info, success, fail) => {
                if (this.props.plan && this.props.planGroup) {
                    const planId = this.props.plan.id;
                    const planGroupId = this.props.planGroup.id;
                    const fetcher = async () => {
                        let preservedEvents = [];
                        try {
                            const { data } = await getCurrentPreserves(planId);
                            preservedEvents = preservedEvents.concat(data);
                        }
                        catch (error) {
                            throw error;
                        }
                        try {
                            const { data } = await getHolidays(planGroupId, dayjs(info.start).format('YYYY-MM-DD'), dayjs(info.end).format('YYYY-MM-DD'));
                            preservedEvents = preservedEvents.concat(data);
                        }
                        catch (error) {
                            throw error;
                        }
                        return preservedEvents;
                    };
                    fetcher()
                        .then(events => success(events))
                        .catch(error => fail(error));
                }
                else {
                    success([]);
                }
            },
            selectLongPressDelay: 100,
            selectOverlap: false,
            selectable: true,
            unselectAuto: false,
            allDaySlot: false,
            slotLabelContent: (args) => {
                return dayjs(args.date).format('H:mm');
            },
            validRange: {
                start: expectStartDate.toDate()
            },
            slotDuration: { minute: duration + intermission },
            slotMinTime: planGroup?.openingTime ?? '00:00:00',
            slotMaxTime: planGroup?.closingTime ?? '24:00:00',
            selectAllow: this.selectAllow,
        };
    }
    render() {
        return _jsx(PreactFullCalendar, Object.assign({}, this.options), void 0);
    }
    selectAllow(selectInfo) {
        var start = dayjs(selectInfo.start);
        if (start.isAfter(dayjs()) === false) {
            console.debug('before current timestamp selected');
            return false;
        }
        const { preserveStartDateTime, preserveEndDateTime, duration, intermission, } = this.state;
        var end = dayjs(selectInfo.end);
        console.log({ start: start.unix(), end: end.unix() });
        console.log({ preserveStart: preserveStartDateTime.unix(), end: preserveEndDateTime.unix() });
        console.debug(`after perserve end time ${preserveEndDateTime.isBefore(end)}`);
        console.debug(`before perserve start time ${preserveStartDateTime.isBefore(start)}`);
        // 開始日以前、終了日以降の場合は選択させない
        const inPeriodStart = compareBetween(preserveStartDateTime, preserveEndDateTime, start);
        const inPeriodEnd = compareBetween(preserveStartDateTime, preserveEndDateTime, end);
        console.log({ inPeriodStart, inPeriodEnd });
        if (inPeriodStart === false || inPeriodEnd === false) {
            console.debug('before preserve start date or after preserve end date');
            return false;
        }
        // 所要時間、クールタイムに合致しない選択は許可しない
        const requirementMinute = duration + intermission;
        const diff = end.diff(start, 'minutes');
        if (requirementMinute === diff) {
            this.props.callback(start, end);
            return true;
        }
        return false;
    }
}
